<template>
  <el-drawer
    size="50%"
    :title="title"
    :with-header="true"
    :visible.sync="isDrawer"
    @close="handleClosed"
  >
    <el-container direction="vertical">
      <el-main>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form
              ref="el_form"
              v-loading="loading"
              size="mini"
              label-width="120px"
              label-position="left"
              :model="model"
              :rules="rules"
            >
              <div class="flex mb-20">
                <el-image
                  v-if="isView"
                  style="width: 100px; height: 100px"
                  :src="model.PictureDirectory"
                  fit="cover"
                  class="box"
                ></el-image>

                <span class="box">{{ model.FullName }}</span>
              </div>

              <el-form-item label="Nombre" prop="FirstName" v-if="!isView">
                <el-col :span="8" style="padding-left: 0">
                  <el-input
                    v-model="model.FirstName"
                    :disabled="isView"
                    placeholder="Primer nombre"
                    @change="model.FirstName = titleCase($event)"
                  ></el-input>
                </el-col>

                <el-col :span="8">
                  <el-input
                    v-model="model.MiddleName"
                    :disabled="isView"
                    placeholder="Segundo nombre"
                    @change="model.MiddleName = titleCase($event)"
                  ></el-input>
                </el-col>

                <el-col :span="8" style="padding-right: 0">
                  <el-input
                    v-model="model.SurName"
                    :disabled="isView"
                    placeholder="Apellidos"
                    @change="model.SurName = titleCase($event)"
                  ></el-input>
                </el-col>
              </el-form-item>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="Telefono" prop="PhoneNumber">
                    <el-col :span="18" style="padding-left: 0">
                      <el-input
                        v-model="model.PhoneNumber"
                        :disabled="isView"
                        placeholder="Numero de telefono"
                      ></el-input>
                    </el-col>

                    <el-col :span="6" style="padding-right: 0">
                      <el-input
                        v-model="model.ExtensionNumber"
                        :disabled="isView"
                        placeholder="Ext."
                      ></el-input>
                    </el-col>
                  </el-form-item>

                  <el-form-item label="Movil">
                    <el-input
                      v-model="model.MobilPhoneNumber"
                      :disabled="isView"
                      placeholder="Numero movil"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="Email" prop="Email">
                    <el-input
                      v-model="model.Email"
                      :disabled="isView"
                      placeholder="Correo electronico"
                    ></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-form-item label="Puesto">
                    <el-input
                      v-model="model.JobTitle"
                      :disabled="isView"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="Fecha nacimiento">
                    <el-date-picker
                      type="date"
                      placeholder="Pick a date"
                      v-model="model.Birthday"
                      style="width: 100%"
                      :disabled="isView"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="Vendedor">
                    <el-select
                      v-model="model.SalesPersonCode"
                      placeholder="Seleccionar Vendedor"
                      @change="handleChangeSeller"
                    >
                      <el-option
                        v-for="item in list_vendors"
                        :key="item.value"
                        :value="item.value"
                        :label="item.label"
                        :disabled="!item.IsEnabled"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="Direccion">
                    <el-input
                      v-model="model.ContactAddress"
                      :disabled="isView"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="Direccion 2">
                    <el-input
                      v-model="model.ContactAddressTwo"
                      :disabled="isView"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="Ciudad">
                    <el-input
                      v-model="model.City"
                      :disabled="isView"
                    ></el-input>
                  </el-form-item>

                  <!-- <el-form-item label="Actualizacion">
                    <el-date-picker
                      type="date"
                      placeholder="Fecha de actualizacion"
                      v-model="model.LasDateModified"
                      :disabled="false"
                    ></el-date-picker>
                  </el-form-item> -->
                </el-col>

                <el-col :span="12">
                  <el-form-item label="WhatsApp">
                    <el-input
                      v-model="model.WhatsApp"
                      :disabled="isView"
                      placeholder="Numbero del WhatsApp"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="Instgram">
                    <el-input
                      v-model="model.Instagram"
                      :disabled="isView"
                      placeholder="Link del instragram"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="Facebook">
                    <el-input
                      v-model="model.Facebook"
                      :disabled="isView"
                      placeholder="Link del facebook"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="Linkedin">
                    <el-input
                      v-model="model.Linkedin"
                      :disabled="isView"
                      placeholder="Link del linkeding"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-form-item label="" label-width="0">
                <el-button
                  v-if="!isView"
                  type="primary"
                  v-loading="loading"
                  @click="onSubmit()"
                  >{{ button_submit_text }}</el-button
                >
                <el-button @click="drawer == false">Cancel</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </el-drawer>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ConctactForm",
  props: {
    title: {
      type: String,
      default: "Crear Contacto",
      required: false
    },
    drawer: {
      type: Boolean,
      default: false
    },
    isView: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isDrawer: false,
      button_submit_text: "Crear",
      loading: false,
      ruleForm: {
        FirstName: ""
      },
      rules: {
        FirstName: [
          {
            required: true,
            message: "Ingrese el nombre del contacto",
            trigger: "blur"
          }
        ],
        PhoneNumber: [
          {
            required: true,
            message: "Ingrese el Telefono del contacto",
            trigger: "blur"
          }
        ],
        Email: [
          {
            required: true,
            message: "Ingrese el correo del contacto",
            trigger: "blur"
          }
        ]
      },
      model: {
        Id: 0,
        ContactCode: null,
        CustomerCode: null,
        Name: "",
        FullName: null,
        NameTwo: null,
        ContactAddress: null,
        ContactAddressTwo: null,
        City: null,
        PhoneNumber: null,
        MobilePhoneNumber: null,
        SalesPersonCode: null,
        LastDateModified: null,
        Email: null,
        CompanyNumber: null,
        CompanyName: null,
        Type: 1, // Type in ContactType
        ExtensionNumber: null,
        FirstName: null,
        MiddleName: null,
        SurName: null,
        JobTitle: null,
        Blocked: 0,
        PictureDirectory: null,
        Birthday: null,
        ContactJobResponsabilities: [
          {
            ContactCode: null,
            ResponsabilityCode: null,
            Description: null,
            Selected: true,
            CompanyId: null
          }
        ],
        CompanyId: null,
        IsActived: true,
        Instagram: null,
        FaceBook: null,
        Linkedin: null,
        WhatsApp: null
      }
    };
  },
  created() {
    if (this.isEdit) {
      this.button_submit_text = "Editar";
    } else {
      this.button_submit_text = "Crear";
    }
  },
  destroyed() {
    this.$emit("update:drawer", false);
  },
  computed: {
    ...mapGetters({ list_vendors: "sellers/list_to_select" })
  },
  methods: {
    handleClosed() {
      this.$emit("update:drawer", false);
      this.$refs.el_form.resetFields();
    },
    onSubmit() {
      // console.log(formName.FirstName);

      this.$refs.el_form.validate((valid) => {
        if (valid) {
          // Trims every field programatically
          for (const property in this.model) {
            if (typeof this.model[property] === "string") {
              this.model[property] = this.model[property].trim();
            }
          }

          this.loading = true;

          this.model.CompanyId = this.currentCompany;
          this.model.LastDateModified = null;
          this.model.Name =
            this.model.FirstName +
            " " +
            this.model.MiddleName +
            " " +
            this.model.SurName;

          // this.model.CustomerCode = "CL000109";

          if (this.isEdit) {
            // Actualizar
          } else {
            this.$http
              .post("/api/contacts", this.model)
              .then(() => {
                this.$refs.el_form.resetFields();
                this.isDrawer = false;
                this.$emit("update:drawer", false);
                this.$message.success("Contacto creado.");
              })
              .catch((error) => {
                console.error(error);
                this.$message.error("Error al crear contacto.");
              })
              .finally(() => {
                this.loading = false;

                // Resets every field in the form programatically
                this.model = this.resetForm();
              });
          }
        } else {
          return false;
        }
      });
    },
    titleCase(str) {
      str = str.toLowerCase().split(" ");

      let final = [];

      for (let word of str) {
        final.push(word.charAt(0).toUpperCase() + word.slice(1));
      }

      return final.join(" ");
    },
    // TODO: Esto solo se usa con el selector de vendedor
    handleChangeSeller(seller) {
      const vendor = this.list_vendors.find(
        (vendor) => vendor.value === seller
      );
      this.model.SalesPersonName = vendor.label;
    },
    resetForm() {
      return {
        Id: 0,
        ContactCode: null,
        CustomerCode: null,
        Name: "",
        FullName: null,
        NameTwo: null,
        ContactAddress: null,
        ContactAddressTwo: null,
        City: null,
        PhoneNumber: null,
        MobilePhoneNumber: null,
        SalesPersonCode: null,
        LastDateModified: null,
        Email: null,
        CompanyNumber: null,
        CompanyName: null,
        Type: 1, // Type in ContactType
        ExtensionNumber: null,
        FirstName: null,
        MiddleName: null,
        SurName: null,
        JobTitle: null,
        Blocked: 0,
        PictureDirectory: null,
        Birthday: null,
        ContactJobResponsabilities: [
          {
            ContactCode: null,
            ResponsabilityCode: null,
            Description: null,
            Selected: true,
            CompanyId: null
          }
        ],
        CompanyId: null,
        IsActived: true,
        Instagram: null,
        FaceBook: null,
        Linkedin: null,
        WhatsApp: null
      };
    }
  },
  watch: {
    drawer(newVal) {
      this.isDrawer = newVal;
    }
  }
};
</script>

<style></style>
